const contactData = [
  {
    id: 1,
    title: "Email Address",
    subTitle: "Email us about the website",
    desc1: "Mudraloanhelp0@gmail.com",
    icon: "fa-solid fa-envelope",
  },
  {
    id: 2,
    title: "Phone Number",
    subTitle: "For general website questions",
    desc1: "+91 9873691307",
    icon: "fa-solid fa-phone",
  },
  {
    id: 3,
    title: "Office Address",
    subTitle: "Registered contact address",
    desc1: "B12, Mahipalpur Bypass Road, Mahipalpur, New Delhi - 110037",
    icon: "fa-solid fa-location-dot",
  },
];

export default contactData;
